$(document).ready(function(e){
  console.log(
  "%cCustom JS is ready",
  "background: linear-gradient(to right, #EB9BA3, #000000); color: #FFF; font-weight: bold; font-size: 50px;"
);

//for FAQ  
$(function() {
$('.accordion .acc-headng-main').click(function(){
$(this).parent().toggleClass(' active ');
$(this).parent().siblings().removeClass('active');

$(this).parent().children(".content-box").toggleClass('open').slideToggle();
$(this).parent().siblings().children(".content-box").removeClass('open').slideUp();
return false;
});
});

// for product image zoom
$('.image-selector').lightzoom({
  zoomPower   : 3,
  glassSize   : 400
});

//for quickview






  


  

});